import {COMPLETED, DOWNLOADING, INIT, PROCESSING, UPLOADING} from "../../../pages/detection/detection_page";

export default function detectionReducer(state, action) {
    console.log(state)
    console.log(action);
    switch (action.type) {
        case INIT:
            return {...state, status: INIT}
        case UPLOADING:
            return {
                ...state,
                file: action.payload.file,
                src: action.payload.src,
                status: UPLOADING
            }
        case PROCESSING:
            return {
                ...state,
                status: PROCESSING,
            }
        case DOWNLOADING:
            return {
                ...state,
                result: action.payload,
                status: DOWNLOADING
            }
        case COMPLETED:
            return {...state,
                src: action.payload,
                status: COMPLETED
            }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`)
        }

    }
}